import React               from 'react'
import { store }           from 'index'
import { objType }         from 'types';
import { whiteList }       from 'utils/constants';
import { categories }      from 'utils/colors'
import { showDescription } from 'functions/set_data/show_app_buttons'


const useGetUnitValues = (
    val:      objType,
    groupUrl: boolean,
    update:   boolean
) => {

    const state    = store.getState();
    const userInfo = state.data.userInfo;
    const lang     = state.components.lang;
    const hash     = state.content.hash;

    const [
        id, 
        showTopBar, 
        backgroundColor, 
        showDescriptionButton,
        appName,
        showLikes,
        showStar,
        showHeart,
        disabled,
        disabledGrade,
        showApproved
     ] = React.useMemo(() => {

       


        const userIsZvi   = whiteList.includes(userInfo.userEmail)
        const PLUS        = val.plus === 1 || val.plus === "1" || val.plus === true;
        let disable       = val.disabled || (!userInfo.plus && (( val.origin === 'apps' && PLUS ) || (val.origin === 'puzzles' || val.origin === 'interaction')))
        const appID       = (!!val.puzzle_id ? val.puzzle_id : !!val.uid ? `${ val.uid }` : val.lesson_id);
        const description = showDescription(val);
        let   name        = ( lang === 'ara' && val.app_arabic && val.app_arabic.length ) 
                            ? 
                            val.app_arabic 
                            : 
                            (val.app && val.app.length) 
                            ? 
                            val.app
                            : 
                            val.topic 
                            ? 
                            val.topic 
                            : 
                            val.name 
                            ?
                            val.name 
                            : 
                            '';

          
         if (name.includes("היגולים")) {
          name = "שברים במודל העיגולים"
         }
   
         if (val.lesson_id === "Multiplication_table") {
           disable = false;
         }

   
        return[
          appID,
          (val.origin !== 'teacherContent'),
          ((categories[val.origin] && categories[val.origin][1]) || '#EEE' ),
          description,
          name,
          (( !groupUrl && update && hash[appID] && !!hash[appID].totalLikes ) ? true : false ),
          (!groupUrl && update && hash[appID] && hash[appID].selected === 1 ),
          (!groupUrl && update && hash[appID] && hash[appID].approved === '5' ),
          disable,
          val.disabledGrade,
          userIsZvi
        ]
      },[val, update, groupUrl, userInfo, lang, hash])
   
   return{
    id, 
    showTopBar, 
    backgroundColor, 
    showDescriptionButton,
    appName,
    showLikes,
    showStar,
    showHeart,
    disabled,
    disabledGrade,
    showApproved
   }

}

export default useGetUnitValues

